export const generateIntakeOptions = (numberOfSessions = 7) => {
    const currentYear = new Date().getFullYear();

    return Array.from({ length: numberOfSessions }, (_, i) => {
        const year = currentYear - i;
        const session = `${year}-${year + 1}`;

        return {
            value: session,
            label: session,
            year,
            isCurrent: i === 0,
            displayLabel: `${session}${i === 0 ? " (Current)" : ""}`,
        };
    });
};

export const getCurrentSession = () => {
    const year = new Date().getFullYear();
    return `${year}-${year + 1}`;
};

export const getPreviousSessions = (count = 6, startMonth = 7) => {
    const currentSession = getCurrentSession(startMonth);
    const [startYear] = currentSession.split('-').map(Number);

    const sessions = [];
    for (let i = 1; i <= count; i++) {
        const year = startYear - i;
        sessions.push(`${year}-${year + 1}`);
    }

    return sessions;
};


export const formatDateToISO = (dateStr) => {
    if (!dateStr) return '';
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};


export const formatDateToDisplay = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
};


export const isValidDate = (dateStr) => {
    if (!dateStr) return false;
    const match = dateStr.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (!match) return false;

    const [_, day, month, year] = match.map(Number);
    const date = new Date(year, month - 1, day);

    return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
    );
};


export const isFutureDate = (dateStr) => {
    if (!dateStr) return false;
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date > today;
};

export const getAge = (dobStr) => {
    if (!dobStr) return 0;
    const [day, month, year] = dobStr.split('-').map(Number);
    const dob = new Date(year, month - 1, day);
    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age--;
    }

    return age;
};


export const getAcademicYear = (date = new Date(), startMonth = 7) => {
    const year = date.getFullYear();
    const month = date.getMonth();

    let startYear = year;
    if (month < startMonth) {
        startYear = year - 1;
    }

    return `${startYear}-${startYear + 1}`;
};


export const getSessionOptions = (numberOfSessions = 7, startMonth = 7) => {
    const options = generateIntakeOptions(numberOfSessions, startMonth);

    return {
        // For Select dropdown
        selectOptions: options.map(opt => ({
            value: opt.value,
            label: opt.label
        })),

        // With display labels
        displayOptions: options.map(opt => ({
            value: opt.value,
            label: opt.displayLabel
        })),

        // Just values
        values: options.map(opt => opt.value),

        // Current session
        current: options[0]?.value || '',

        // All options with metadata
        all: options
    };
};